class ScheduleSlider {
  constructor(el) {
    this.roots = document.querySelectorAll('.' + el);
    if (!this.roots.length || typeof Swiper === 'undefined') return;

    this.minSlides = 4;
    this.reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    this.canHover = window.matchMedia('(hover: hover)').matches;
    this.spQuery = window.matchMedia('(max-width: 767px)');

    this.items = Array.from(this.roots)
      .map((root) => {
        const viewport = root.querySelector('.c-schedule__viewport');
        const slides = Array.from(root.querySelectorAll('.swiper-slide'));
        return {
          root,
          viewport,
          slides,
          prev: root.querySelector('.js-schedule-prev'),
          next: root.querySelector('.js-schedule-next'),
          count: slides.length,
          swiper: null,
        };
      })
      .filter((item) => item.viewport && item.count >= this.minSlides);

    this.resizeQueued = false;
    this.spQuery.addEventListener('change', () => this.update());
    window.addEventListener('resize', () => {
      if (this.resizeQueued) return;
      this.resizeQueued = true;
      window.requestAnimationFrame(() => {
        this.resizeQueued = false;
        this.updateSpace();
      });
    });
    this.update();
  }

  remSize() {
    const rem = parseFloat(
      getComputedStyle(document.documentElement).fontSize
    );
    return Number.isNaN(rem) ? 10 : rem;
  }

  spaceBetween() {
    return this.remSize() * 3;
  }

  // .c-schedule の左パディング（PC 4rem / SP 2rem）と同じ値。
  // 先頭だけ Swiper の offset にし、右余白は最後のスライド幅に含める
  edgeOffset() {
    return this.spQuery.matches ? this.remSize() * 2 : this.remSize() * 4;
  }

  update() {
    this.items.forEach((item) => {
      if (item.swiper) {
        item.swiper.destroy(true, true);
        item.swiper = null;
      }
      item.swiper = new Swiper(item.viewport, this.options(item));
      this.queueAlign(item.swiper);
    });
  }

  updateSpace() {
    const space = this.spaceBetween();
    const offset = this.edgeOffset();
    this.items.forEach((item) => {
      if (!item.swiper) return;
      item.swiper.params.spaceBetween = space;
      item.swiper.params.slidesOffsetBefore = offset;
      item.swiper.update();
      this.queueAlign(item.swiper);
    });
  }

  queueAlign(swiper) {
    this.alignEndSnap(swiper);
    window.requestAnimationFrame(() => this.alignEndSnap(swiper));
  }

  // 末尾の「少しだけ動く」スナップを捨て、最後のスライド位置で止める
  alignEndSnap(swiper) {
    const grid = swiper.snapGrid;
    if (!grid || grid.length < 2) return;
    const minStep = this.remSize() * 13 + this.spaceBetween();
    while (
      grid.length >= 2 &&
      grid[grid.length - 1] - grid[grid.length - 2] < minStep
    ) {
      grid.splice(grid.length - 2, 1);
    }
    swiper.snapGrid = grid;
    if (typeof swiper.checkOverflow === 'function') {
      swiper.checkOverflow();
    }
  }

  options(item) {
    const offset = this.edgeOffset();
    return {
      slidesPerView: 'auto',
      spaceBetween: this.spaceBetween(),
      slidesOffsetBefore: offset,
      speed: this.reduceMotion ? 0 : 600,
      watchOverflow: true,
      threshold: 8,
      preventClicks: true,
      preventClicksPropagation: true,
      grabCursor: this.canHover,
      navigation: {
        prevEl: item.prev,
        nextEl: item.next,
      },
      a11y: {
        enabled: true,
        slideRole: null,
        prevSlideMessage: '前のスケジュールへ',
        nextSlideMessage: '次のスケジュールへ',
      },
      on: {
        afterInit: (swiper) => this.queueAlign(swiper),
        update: (swiper) => this.queueAlign(swiper),
        resize: (swiper) => this.queueAlign(swiper),
      },
    };
  }
}
